export default {
  // layout
  LAYOUT: {
    header: {
    },
    footer: {
    },
    pageFooter: {
      ___compassBioinformatics: 'コンパスバイオインフォマティクス株式会社'
    }
  },
  // page
  PAGE: {
    main: {
      ___title: 'サーバーを選択してください',
      setting: {
        ___title: '次回から自動で選択',
        ___clear: '設定をクリア',
        ___info: '設定を保存したい場合は、このチェックボックスにチェックを入れてください。次回以降、設定を選び直す必要がなくなります。'
      }
    }
  },
  // component
  COMPONENT: {
    dialog: {
      detectAlert: {
        ___content: 'お使いの地域は<b>{target}</b>と判定しました。\n<b>{target}</b>サーバーへ移動しますか？',
        setting: {
          ___title: '次回から自動で選択',
          ___clear: '設定をクリア'
        },
        button: {
          ___enter: 'はい',
          ___another: 'いいえ'
        }
      },
      redirectAlert: {
        ___content: '{countdown} 秒後に<b>{target}サーバー</b>へ自動転送されます。\nご希望のサーバーではありませんか？',
        setting: {
          ___clear: '設定をリセット'
        },
        button: {
          ___change: '変更する場合はこちら'
        }
      },
      toast: {
        title: {
          ___success: '成功！',
          ___error: 'エラー！'
        }
      },
    }
  },
  // common
  COMMON: {
    regionOptions: {
      ___tw: '台湾',
      ___us: '米国',
      ___jp: '日本'
    },
    button: {
    },
    toast: {
      ___clearSetting: '環境設定がリセットされました。',
      ___clearError: 'エラーが発生したため、環境設定がリセットできませんでした（エラーコード: {code}）。後でもう一度お試しください。',
      ___noPermission: 'No Permission',
      ___pleaseLogin: 'Please Login'
    }
  }
}
